import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";


type StatusSolicitudGastosContingenciaProfesional = {
  status: number | null;
  statusText: string | null;
};


const useGetInfoSolicitudGastosContingenciaProfesionalIt = () => {
  const [loadingGetInfoSolicitudGastosContingenciaProfesionalIt, setLoadingGetInfoSolicitudGastosContingenciaProfesionalIt] = useState(false);
  const [successGetInfoSolicitudGastosContingenciaProfesionalIt, setSuccessGetInfoSolicitudGastosContingenciaProfesionalIt] = useState(false);
  const [errorGetInfoSolicitudGastosContingenciaProfesionalIt, setErrorGetInfoSolicitudGastosContingenciaProfesionalIt] = useState(null);
  const [dataGetInfoSolicitudGastosContingenciaProfesionalIt, setDataGetInfoSolicitudGastosContingenciaProfesionalIt] = useState(null);
  const [statusGetInfoSolicitudGastosContingenciaProfesional, setStatusGetInfoSolicitudGastosContingenciaProfesional] =
    useState<StatusSolicitudGastosContingenciaProfesional>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoSolicitudGastosContingenciaProfesionalIt = async (userId, _cb?: (data: any) => void) => {
    setLoadingGetInfoSolicitudGastosContingenciaProfesionalIt(true);
    setSuccessGetInfoSolicitudGastosContingenciaProfesionalIt(false);
    setErrorGetInfoSolicitudGastosContingenciaProfesionalIt(null);

    try {
      const res = await apiRecord.getInfoSolicitudGastosContingenciaProfesionalIt(userId);
      setStatusGetInfoSolicitudGastosContingenciaProfesional({
        status: res.status,
        statusText: res.statusText
      });
      setLoadingGetInfoSolicitudGastosContingenciaProfesionalIt(false);
      setSuccessGetInfoSolicitudGastosContingenciaProfesionalIt(true);
      setDataGetInfoSolicitudGastosContingenciaProfesionalIt(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }
      return res.data; // Retorna los datos correctamente
    } catch (err) {
      setStatusGetInfoSolicitudGastosContingenciaProfesional({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });
      setLoadingGetInfoSolicitudGastosContingenciaProfesionalIt(false);
      setErrorGetInfoSolicitudGastosContingenciaProfesionalIt(err);
      console.error("Error en getInfoSolicitudGastosContingenciaProfesionalIt:", err);
      throw err;
    }
  };

  return {
    getInfoSolicitudGastosContingenciaProfesionalIt,
    loadingGetInfoSolicitudGastosContingenciaProfesionalIt,
    successGetInfoSolicitudGastosContingenciaProfesionalIt,
    errorGetInfoSolicitudGastosContingenciaProfesionalIt,
    dataGetInfoSolicitudGastosContingenciaProfesionalIt,
    statusGetInfoSolicitudGastosContingenciaProfesional
  };
};

export default useGetInfoSolicitudGastosContingenciaProfesionalIt;